import { ProjectResourceItemBase } from './base/project-resource-item-base';

export class ProjectResourceItem extends ProjectResourceItemBase { }